'use client'

import React, { ReactNode } from 'react';
import { StyledDiv } from './longCopy.styles';

interface ILongCopyProps {
    title: string;
    children: ReactNode;
}

export const LongCopy = ({ title, children }: ILongCopyProps) => {
    return (
        <StyledDiv>
            <h1>{title}</h1>
            <div className="text-wrapper">
                {children}
            </div>
        </StyledDiv>
    );
};
